import createLucideIcon from '../createLucideIcon';

const ChevronDown = createLucideIcon('ChevronDownIcon', [
  ['polyline', { points: '6 9 12 15 18 9', key: '1do0m2' }],
]);

export default ChevronDown;
